import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import tables from "../../../../Data/Tables/Inventory/Received/tables";
import headers from "../../../../Data/Tables/Inventory/Received/headers";
import inventory from "../../../../Data/inventory.json";
import branches from "../../../../Data/branch.json";
import products from "../../../../Data/products.json";
import Status from "../../../../Componets/Status";
import received from "../../../../Data/received.json";
import toast from "react-hot-toast";
import ActionButton from "../../../../Componets/Buttons/action";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_inventories } from "../../../../Controllers/Inventory/Batch";
import { get_all_received } from "../../../../Controllers/Inventory/Received";
import moment from "moment";
import DotIcon from "../../../../Assets/Svg/dot";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";

const InventoryReceivedTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();
  const [previousPage, setPreviousPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      status: headerdata?.status,
      date: headerdata?.date
    });
  };

  const formdata = (data) => {
    if (data?.search && !isSearching) {
      setPreviousPage(pagination.currentPage);
      setIsSearching(true);
    }

    if (!data?.search && isSearching) {
      setIsSearching(false);
      fetchData({
        ...data,
        currentPage: previousPage,
        totalCount: pagination?.totalCount,
        totalPages: pagination?.totalPages,
      });
      return;
    }

    let page = data?.search ? 1 : pagination?.currentPage;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      status: headerdata?.status,
      date: headerdata?.date,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        status: tabledata?.status,
        page: tabledata?.currentPage,
        product: tabledata?.product,
        date: tabledata?.date,
        type: tabledata?.type,
      };

      const products = await get_all_received(data);
      if (products?.status) {
        let data = [];

        products?.data?.data?.map((value, index) => {
          data?.push({
            path: `/app/inventory/received/view/${value?._id}`,
            Number: `#RECEIVED-${value?.number}`,
            Supplier: value?.branch.name,
            Branch: value?.supplier?.name,
            Date: <DateTimeBadge date={value?.date} />,
            Due: <DateTimeBadge date={value?.due_date} />,
            Amount: value?.received_data ? value?.received_data?.total : value?.total?.toFixed(3),
            "Transfer Status": value?.received ? (
              <div className="flex">
                <div className={`my-auto pr-2 text-green-500`}>
                  <DotIcon width={10} height={10} />
                </div>
                <div>Accepted</div>
              </div>
            ) : (
              <div className="flex">
                <div className={`my-auto pr-2 text-red-500`}>
                  <DotIcon width={10} height={10} />
                </div>
                <div>Not-accepted</div>
              </div>
            ),
            Status: <Status status={value?.status} />,
            Action: !value?.received ? (
              <ActionButton
                edit={`/app/inventory/received/edit/${value?._id}`}
                id={value?._id}
                api="delete-transfer"
                actiondata={actiondata}
                headers={header}
              />
            ) : null,
          });
        });

        setPagination({
          currentPage: products?.data?.currentPage,
          totalCount: products?.data?.totalCount,
          totalPages: products?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default InventoryReceivedTable;
